import IntlMessages from "../../../../util/IntlMessages";
import Checkbox from "../../../BP2Components/Checkbox";
import React from "react";
import { tDevForm } from "../../RenderDevEditForm";
import "./CheckboxSection.less";
import "../../RenderDevEditForm.less";

const CheckboxSection = ({ state, setField }: tDevForm) => {
   return (
      <div className="dev-checkbox-section">
         <div className="section-title">
            <IntlMessages id="devForm.fieldSettings" />:
         </div>

         <div className="dev-checkbox-section__rows dev-form-group-vertical-12">
            <div className="dev-form-row dev-form-row-space-between">
               <label>
                  <IntlMessages id="devForm.createSubfolderWithInstanceId" />:
               </label>
               <Checkbox
                  checked={state.Subfolder}
                  onChange={(e) => setField?.("Subfolder", e.target.checked)}
               />
            </div>

            <div className="dev-form-row dev-form-row-space-between">
               <label>
                  <IntlMessages id="devForm.required" />:
               </label>
               <Checkbox
                  checked={state.Required}
                  onChange={(e) => setField?.("Required", e.target.checked)}
               />
            </div>

            <div className="dev-form-row dev-form-row-space-between">
               <label>
                  <IntlMessages id="devForm.hidden" />:
               </label>
               <Checkbox
                  checked={state.Hidden}
                  onChange={(e) => setField?.("Hidden", e.target.checked)}
               />
            </div>

            <div className="dev-form-row dev-form-row-space-between">
               <label>
                  <IntlMessages id="devForm.hiddenOnPrint" />:
               </label>
               <Checkbox
                  checked={state.hiddenOnPrint}
                  onChange={(e) => setField?.("hiddenOnPrint", e.target.checked)}
               />
            </div>

            <div className="dev-form-row dev-form-row-space-between">
               <label>
                  <IntlMessages id="devForm.editable" />:
               </label>
               <Checkbox
                  checked={state.Editable}
                  onChange={(e) => setField?.("Editable", e.target.checked)}
               />
            </div>

            <div className="dev-form-row dev-form-row-space-between">
               <label>
                  <IntlMessages id="devForm.disabled" />:
               </label>
               <Checkbox
                  checked={state.Transparency}
                  onChange={(e) => setField?.("Transparency", e.target.checked)}
               />
            </div>

            <div className="dev-form-row dev-form-row-space-between">
               <label>
                  <IntlMessages id="devForm.useAsTag" />:
               </label>
               <Checkbox
                  checked={state.toggleTag}
                  onChange={(e) => setField?.("toggleTag", e.target.checked)}
               />
            </div>

            <div className="dev-form-row dev-form-row-space-between">
               <label>
                  <IntlMessages id="devForm.barcodeScanningSupport" />:
               </label>
               <Checkbox
                  checked={state.barcode_support}
                  onChange={(e) => setField?.("barcode_support", e.target.checked)}
               />
            </div>
         </div>
      </div>
   );
};

export default CheckboxSection;
